import { Component } from '@angular/core';

@Component({
  selector: 'pages',
  template: `
    <div>
      <div class="container">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  styleUrls: ["./pages.component.scss"]
})

export class PagesComponent {
  menuCollapse = false
}
